export function FormatDate(date: string): string {
  if (!date) {
    return '-';
  }
  return new Date(date).toISOString().split('T')[0];
}
